/* Built In Imports */

/* External Imports */
import { Box, Flex } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { ProgramSupportSt } from '@ieo/Common/CompLangConfig';
import SingleImage from './SingleImage';

/* Services */
/* Styles */

/**
 * @param {Object} card
 * @param {String} region
 * @param {String} lang
 * @param {String} flexBasis
 * @returns
 */
const ProgramSupportCard = ({ card, lang, region, flexBasis, pageData }) => {
  const descText = render(card?.description);

  return (
    <Box
      w={{ base: '100%', sm: '318px', md: '47%', lg: '30%' }}
      flexBasis={{ base: 'auto', md: 'auto', lg: flexBasis }}
    >
      <Box
        h="auto"
        maxW={{ base: '100%', md: '100%', lg: '318px' }}
        bg="#F1EBDF"
        display="flex"
        justifyContent="space-between"
        flexDir="column"
        minH={'195px'}
      >
        <Box maxW={'100'} minH={'66px'} alignSelf={'auto'}>
          <SingleImage
            my="0"
            sectionContent={card?.image}
            sync={true}
            w={{ base: '78px' }}
            h={{ base: '78px' }}
            mt={'-38px'}
            objectFit="contain"
            px={'0px'}
          />
        </Box>
        <Box
          w="100%"
          p={0}
          borderLeft={{
            base: lang === 'ar' ? 'none' : '7px solid #A81D28',
            sm: lang === 'ar' ? 'none' : '6px solid #A81D28',
          }}
          borderRight={{
            base: lang === 'ar' ? '7px solid #A81D28' : 'none',
            sm: lang === 'ar' ? '6px solid #A81D28' : 'none',
          }}
          h={{ base: '55%', md: '63%' }}
          minH={'132px'}
          pb="20px"
          display={'flex'}
          fontFamily="FedraSansStd-book"
          flexDir="column"
          px="20px"
          dir={lang == 'ar' ? 'rtl' : 'ltr'}
        >
          <Flex w="100%" justifyContent="space-between" flexDirection="column">
            <StructuredTextParser
              className="program-support-card-title"
              fontSize={{ base: '20px', md: '22px' }}
              lineHeight={{ base: '25px', md: '28px' }}
              display={{ base: 'block', sm: 'block' }}
              {...ProgramSupportSt[lang].stText}
              color="#423E3B !important"
              mt="0"
              str={`${descText} `}
            />
          </Flex>
        </Box>
      </Box>
      <style global jsx>
        {`
          .program-support-card-title strong {
            color: #3B444B;
          }
        `}
      </style>
    </Box>
  );
};

export default ProgramSupportCard;
